<template>
  <div class="real-container">
    <div class="main-banner-wrap">
      <div class="main-con">
        <div class="con-right t-con-text">
          <!-- 230130 메인배너로고 이미지 추가 + container-1-banner-logo, text-1, text-3 클래스 추가 + 문구 변경 -->
          <div class="container-1-title" data-aos="fade-up">
            <div class="container-1-banner-logo m-none">
              <img
                src="@/assets/imgs/main_banner_logo@2x.png"
                alt="메인배너로고"
              />
            </div>
            <div class="container-1-title-1">
              <span class="text-1"> 시민생활종합플랫폼 <br /> </span>
            </div>
            <div class="container-1-text-1">
              <span class="text-3">배달</span>
              <span class="text-2">부터</span>
              <span class="text-3" style="margin-left:5px">교통</span>
              <span class="text-2">까지</span>
              <br />

              <span class="text-2">대구의 모든 것을</span>
              <br />

              <span class="text-3">하나의 앱으로!</span>
            </div>
          </div>
          <!-- <div data-aos="fade-up">
            <div>
              <span class="container-1-text-1">
                <span class="font-highlight">주</span
                ><span class="font-highlight">문</span>은
              </span>
              <span class="text-2"> 대구로 </span>
            </div>
            <div>
              <span class="container-1-text-1">
                <span class="font-highlight">배</span
                ><span class="font-highlight">달</span>은
              </span>
              <span class="text-2"> 댁으로 </span>
            </div>
            <p>
              시민과 소상공인 모두가 행복한 대구형 배달앱에서 착한 소비
              시작하세요!
            </p>
          </div> -->
          <div class="main-banner-appbtn" data-aos="fade-up">
            <button @click="appdownand()" class="container-1-btn-top btn-and">
              <img
                src="@/assets/imgs/ic_googleplay_logo@2x.png"
                class="container-1-btn-img"
                alt="안드로이드"
              />
              <!--                <div class="container-1-btn-text">안드로이드 다운받기</div>-->
            </button>
            <button @click="appdownios()" class="container-1-btn-top btn-ios">
              <img
                src="@/assets/imgs/ic_appstore_logo@2x.png"
                class="container-1-btn-img"
                alt="아이폰"
              />
              <!--                <div class="container-1-btn-text">아이폰 다운받기</div>-->
            </button>
          </div>
          <div class="main-banner-applybtn" data-aos="fade-up">
            <button class="container-1-btn-bottom" @click="goEnter()">
              <a>
                <div class="container-btn-bottom-text">간편 입점 신청</div>
              </a>
            </button>
            <button class="container-1-btn-bottom mr-0" @click="goOwner()">
              <a>
                <div class="container-btn-bottom-text">
                  사장님 사이트 바로가기
                </div>
              </a>
            </button>
            <button class="container-1-btn-bottom mr-0" @click="goFaq()">
              <a>
                <div class="container-btn-bottom-text">
                  고객지원 사이트 바로가기
                </div>
              </a>
            </button>
            <!--            <button class="container-1-btn-bottom mr-0" @click="goCheck()">
              <a>
                <div class="container-btn-bottom-text">입점 내역 조회</div>
              </a>
            </button>-->
          </div>
          <div class="container-1-left-content">
            <img
              src="@/assets/imgs/img_260515@2x.png"
              class="container-1-left-content-img"
              alt="메인배너이미지 대구로모바일"
            />
          </div>
        </div>
        <div class="container-1-left-content">
          <img
            src="@/assets/imgs/img_260515@2x.png"
            class="container-1-left-content-img"
            alt="메인배너이미지 대구로모바일"
          />
        </div>
        <div class="container-1-right-content">
          <!-- 230130 메인배너로고 이미지 추가 + container-1-banner-logo, text-1, text-3 클래스 추가 + 문구 변경 -->
          <div class="container-1-title" data-aos="fade-up">
            <div class="container-1-banner-logo">
              <img
                src="@/assets/imgs/main_banner_logo@2x.png"
                alt="메인배너로고"
              />
            </div>
            <div class="container-1-title-1">
              <span class="text-1"> 시민생활종합플랫폼 <br /> </span>
            </div>
            <div class="container-1-text-1">
              <span class="text-3" style="line-height:0">배달</span>
              <span class="text-2">부터</span>
              <span class="text-3" style="margin-left: 7px">교통</span>
              <span class="text-2">까지</span>
              <br>              
              <span class="text-2">대구의 모든 것을</span>
              <br>
              <span class="text-3"> 하나의 앱으로!</span>
            </div>
          </div>
          <div class="main-banner-appbtn oh" data-aos="fade-up">
            <div class="main-banner-w main-banner-l">
              <p>앱 바로받기</p>
              <img src="../assets/imgs/img_QR@2x.png" alt="앱큐알코드" />
            </div>
            <div class="main-banner-w main-banner-r">
              <p>스토어 바로가기</p>
              <button @click="appdownand()" class="container-1-btn-top btn-and">
                <img
                  src="@/assets/imgs/ic_googleplay_logo@2x.png"
                  class="container-1-btn-img"
                  alt="안드로이드"
                />
                <!--                <div class="container-1-btn-text">안드로이드 다운받기</div>-->
              </button>
              <button @click="appdownios()" class="container-1-btn-top btn-ios">
                <img
                  src="@/assets/imgs/ic_appstore_logo@2x.png"
                  class="container-1-btn-img"
                  alt="아이폰"
                />
                <!--                <div class="container-1-btn-text">아이폰 다운받기</div>-->
              </button>
            </div>
          </div>
          <!--          <div>
            <router-link :to="{ name: 'Enter_Info' }">
              <div class="container-1-btn-bottom">
                <div class="container-btn-bottom-text">간편 입점 신청</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'User_Check' }">
              <div class="container-1-btn-bottom mr-0">
                <div class="container-btn-bottom-text">입점 내역 조회</div>
              </div>
            </router-link>
          </div>-->
        </div>
      </div>
    </div>

    <div class="contents-wrap sec-1">
      <div class="container-con contents-main">
        <div class="sec-1-con">
          <p class="sec-1-tit" data-aos="fade-up">
            대구시와 함께 대구로에서<br />
            착한 소비 선순환을 실천하세요!
          </p>
          <ul>
            <li data-aos="fade-up">
              <div class="img-cover">
                <img
                  src="../assets/imgs/img_person1_232px@3x.png"
                  alt="소상공인"
                />
              </div>
              <div class="text-cover">
                <div class="sec-1-text">
                  <b style="line-height: 2">소상 공인</b>
                  <span>
                    수수료 절감<br />
                    홍보 효과 증대<br />
                    착한 식당
                  </span>
                </div>
              </div>
            </li>
            <li data-aos="fade-up">
              <div class="img-cover">
                <img
                  src="../assets/imgs/img_person2_232px@3x.png"
                  alt="대구시"
                />
              </div>
              <div class="text-cover">
                <div class="sec-1-text">
                  <b style="line-height: 2">대구시</b>
                  <span>
                    지역 상권 활성화<br />
                    지역 경제 발전<br />
                    착한 행정
                  </span>
                </div>
              </div>
            </li>
            <li data-aos="fade-up">
              <div class="img-cover">
                <img
                  src="../assets/imgs/img_person3_232px@3x.png"
                  alt="대구시민"
                />
              </div>
              <div class="text-cover">
                <div class="sec-1-text">
                  <b style="line-height: 2">대구 시민</b>
                  <span>
                    다양한 혜택<br />
                    가격 할인 이벤트<br />
                    착한 소비
                  </span>
                </div>
              </div>
            </li>
            <!-- 230130 -->
            <li data-aos="fade-up">
              <div class="img-cover">
                <img
                  src="../assets/imgs/img_person4_mobile.png"
                  alt="택시기사"
                />
              </div>
              <div class="text-cover">
                <div class="sec-1-text">
                  <b style="line-height: 2">택시기사</b>
                  <span>
                    낮은 수수료<br />
                    빠른 호출<br />
                    안심귀가
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <div class="sec-1-img" data-aos="fade-up">
            <img
              src="../assets/imgs/person_pc.png"
              alt="소상공인, 대구시, 대구시민"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 230130 div 4 이미지 등록완료 + 컨텐츠 이미지 등록완료 + sub-sec-1, no-bottom-margin, contents-main-sub-img 클래스 추가 + css web작업 완료 + 모바일용 이미지 추가 + 모바일/웹/태블릿 이미지 전환을 위해 m-none,w-none,t-none 클래스 적용 -->
    <div class="sub-sec-1">
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img src="@/assets/imgs/mockup_biz@2x.png" alt="모바일 앱 이미지" />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              height="479px"
              src="@/assets/imgs/contents_biz@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_biz@2x.png"
              alt="모바일 앱 이미지"
            />
            <div class="btn-row">
            <button class="container-btn-img-bottom-white" @click="goLinkService()">
              <a>
                <div class="container-btn-img-bottom-text-black">
                  비즈 서비스 소개
                </div>
              </a>
            </button>
            <button class="container-btn-img-bottom" @click="goLink()">
              <a>
                <div class="container-btn-img-bottom-text">
                  비즈 기업 회원가입
                </div>
              </a>
            </button>
            </div>
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_delivery_260303.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_delivery@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_delivery@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_goodstore@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_goodstore@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_goodstore@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_taxi@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_taxi@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_taxi@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_drive@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_drive@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_drive@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_market@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_market@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_market@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img src="@/assets/imgs/mockup_bus@2x.png" alt="모바일 앱 이미지" />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_bus@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_bus@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_flower@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_flower@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_flower@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <!-- <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_eletrical@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_electrical@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_electrical@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div> -->
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_hospital@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_hospital@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_hospital@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div>
      <!-- <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img no-bottom-margin" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_reservation@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-sub-img" data-aos="fade-up">
            <img
              class="m-none"
              src="@/assets/imgs/contents_reservation@2x.png"
              alt="모바일 앱 이미지"
            />
            <img
              class="w-none t-none"
              src="@/assets/imgs/m_contents_reservation@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
        </div>
      </div> -->
    </div>
    <!-- 230130 이미지수정 + 문구수정 + sub-sec-2 클래스 추가 -->
    <div class="sub-sec-2">
      <div class="contents-wrap"></div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_benefit_260303.png"
              alt="모바일 앱 이미지"
              class="benefit1-image"
            />
          </div>
          <div class="contents-main-text">
            <p class="main-headtit" data-aos="fade-up">즐거운 할인혜택 1</p>
            <p class="main-headtext" data-aos="fade-up">
              가입 후 첫 이용시<br />
              즉시 할인!
            </p>
            <p class="main-context" data-aos="fade-up">
              배달 첫 주문 3천원 + 재 주문 2천원!<br />
              최대 5,000원 할인
            </p>
            <p class="main-context sub-context" data-aos="fade-up">
              *예산 소진시 까지
            </p>
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_benefit2@2x.png"
              class="container-2-img"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-text">
            <p class="main-headtit" data-aos="fade-up">즐거운 할인혜택 2</p>
            <p class="main-headtext" data-aos="fade-up">
              이용할수록 쌓이는<br />
              통합 마일리지 0.5% 혜택
            </p>
            <p class="main-context" data-aos="fade-up">
              대구로 이용하고 마일리지 쌓아<br />
              더 저렴하게 이용해보세요!
            </p>
          </div>
        </div>
      </div>
      <div class="contents-wrap">
        <div class="container-con contents-main">
          <div class="contents-main-img" data-aos="fade-up">
            <img
              src="@/assets/imgs/mockup_benefit3@2x.png"
              alt="모바일 앱 이미지"
            />
          </div>
          <div class="contents-main-text">
            <p class="main-headtit" data-aos="fade-up">즐거운 할인혜택 3</p>
            <p class="main-headtext" data-aos="fade-up">
              대구로페이로 온라인 결제<br />
              가능한 유일한 어플!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-2">
      <div class="container-con contents-main">
        <div class="sec-2-con">
          <p class="sec-2-tit" data-aos="fade-up">
            대구로 <span class="font-highlight">소</span
            ><span class="font-highlight">상</span
            ><span class="font-highlight">공</span
            ><span class="font-highlight">인</span>을 위한<br />
            착한 소비 배달앱 대구로
          </p>
          <ul>
            <li>
              <div class="sec-2-text">
                <span class="circle-text" data-aos="fade-up">2%</span>
                <b data-aos="fade-up">착한 수수료 2%</b>
                <span data-aos="fade-up">
                  중개 수수료 2%<br />
                  카드결제 수수료 2.2%
                </span>
              </div>
            </li>
            <li>
              <div class="sec-2-text">
                <span class="circle-text" data-aos="fade-up"
                  >24<span>hr</span></span
                >
                <b data-aos="fade-up">실시간 정산 서비스</b>
                <span data-aos="fade-up">
                  카드 매출도 추가 비용<br />
                  없이 24시간 내 정산
                </span>
              </div>
            </li>
            <li>
              <div class="sec-2-text">
                <span class="circle-text" data-aos="fade-up"
                  >1<span>free</span></span
                >
                <b data-aos="fade-up">매일 자유 이벤트</b>
                <span data-aos="fade-up">
                  추가 광고비 없이<br />
                  매일 1회 이벤트 진행
                </span>
              </div>
            </li>  
          </ul>
        </div>
      </div>
    </div>

    <!-- jskang 220728: 예약홍보섹션 추가 css설정을 위해 contents-reserve-text, contents-reserve-img, contents-reserve, img-reserve-desktop, img-reserve-mobile 클래스 추가함 -->
    <!-- <div class="contents-wrap">
      <div class="container-con contents-main contents-reserve">
        <div class="contents-reserve-text">
          <p class="main-headtext" data-aos="fade-up">
            줄 서지 말고 간편하게<br />
            <span class="font-highlight">식당 예약</span>하세요!
          </p>
          <p class="main-context" data-aos="fade-up">
            맛집가면 기다리는게 일상이였나요?<br class="br-mobile"> 간편하게 날짜 지정하고 예약하세요!
          </p>
        </div>
        <div class="contents-reserve-img" data-aos="fade-up">
          <img
            src="@/assets/imgs/img_reserve_section_desktop.png"
            alt="데스크톱 앱 이미지"
            class="img-reserve-desktop"
          />
          <img
            src="@/assets/imgs/img_reserve_section_mobile.png"
            alt="모바일 앱 이미지"
            class="img-reserve-mobile"
          />
        </div>
      </div>
    </div> -->

    <!-- 220621 작업내용 : v-for="post in postList" 에서 v-for="(post, index) in postList" 로 수정, :key="post.idx"에서 :key="index"로 수정,
post.link post.img post.title 에서 각 post.MAIN_URL post.THUMBNAIL_URL post.CONTENTS_TITLE 로 수정-->
    <!-- 230130 썸네일 이미지 캐싱 우회를 위해 이미지 url 뒤 ? Date.now() 추가 -->
    <div class="sec-3" v-if="postList">
      <div class="container-con contents-main">
        <div class="sec-3-con">
          <p class="sec-tit" data-aos="fade-up">
            대구로
            <span class="text-highlight">소</span>
            <span class="text-highlight">식</span>을 댁으로!
          </p>
          <ul>
            <li v-for="(post, index) in postList" :key="index">
              <a :href="post.MAIN_URL" target="_blank">
                <div class="sec-3-li">
                  <span class="rectangle-pic" data-aos="fade-up"
                    ><img
                      :src="post.THUMBNAIL_URL + '?' + Date.now()"
                      alt="대구로 소식"
                  /></span>
                  <span class="rectangle-text" data-aos="fade-up">
                    {{ post.CONTENTS_TITLE | substring }}
                  </span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 230130 m-none 클래스 정리 + iframe16To9 클래스 추가 -->
    <div class="sec-4">
      <div class="container-con contents-main">
        <div class="sec-4-con">
          <p class="sec-tit" data-aos="fade-up">
            <span class="text-highlight">주</span>
            <span class="text-highlight">문</span>은 대구로
            <span class="text-highlight">배</span>
            <span class="text-highlight">달</span>은 댁으로
          </p>
          <p class="sec-sub-tit" data-aos="fade-up">
            지금 바로 대구로에서 착한 소비 실천하세요!
          </p>
          <div class="sec-4-video iframe16To9" data-aos="fade-up">
            <!--            <video controls controlsList="nodownload" class="daegu-m4">
              <source src="@/assets/media/daeguro.mp4" type="video/mp4" />
            </video>-->
            <iframe
              :src="video[Math.round(Math.random() * 0)].link"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <!-- 230130 택시 youtube 추가 -->
          <p class="sec-tit" data-aos="fade-up">대구 시민이면 대구로택시</p>
          <p class="sec-sub-tit" data-aos="fade-up">
            착한 소비 선순환 대구로택시!
          </p>
          <div class="sec-4-video iframe16To9" data-aos="fade-up">
            <!--            <video controls controlsList="nodownload" class="daegu-m4">
              <source src="@/assets/media/daeguro.mp4" type="video/mp4" />
            </video>-->
            <iframe
              :src="video[Math.round(Math.random() * 0) + 1].link"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <ul data-aos="fade-up">
            <li>
              <button @click="appdownand()" class="btn-and">
                <img
                  src="@/assets/imgs/ic_googleplay_logo@2x.png"
                  class="container-1-btn-img m-none"
                  alt="안드로이드"
                />
                <img
                  src="@/assets/imgs/ic_googleplay_logo_w@2x.png"
                  class="container-1-btn-img w-none t-none"
                  alt="안드로이드"
                />
              </button>
            </li>
            <li>
              <button @click="appdownios()" class="btn-ios">
                <img
                  src="@/assets/imgs/ic_appstore_logo@2x.png"
                  class="container-1-btn-img"
                  alt="아이폰"
                />
              </button>
            </li>
            <li class="m-none">
              <button class="btn-line-b" @click="goEnter()">
                간편 입점 신청
              </button>
            </li>
            <!--            <li class="m-none">
              <button class="btn-line-b" @click="goCheck()">
                입점 내역 조회
              </button>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <!-- 230130 con-left div에 m-none 클래스 추가 적용 + m-con-text div에 m-none 클래스 추가 적용 -->
    <div class="container-wrap w-none t-none">
      <div class="container-con container-con-appdown">
        <div class="con-left m-none" data-aos="fade-up">
          <img
            src="@/assets/imgs/daeguro_logo.png"
            class="container-2-img"
            alt="모바일 앱 이미지"
          />
        </div>
        <div class="con-right m-con-text">
          <div class="m-con-text m-none" data-aos="fade-up">
            <div>
              <span class="container-1-text-1">
                <span class="font-highlight">주</span
                ><span class="font-highlight">문</span>은
              </span>
              <span class="text-2"> 대구로 </span>
            </div>
            <div>
              <span class="container-1-text-1">
                <span class="font-highlight">배</span
                ><span class="font-highlight">달</span>은
              </span>
              <span class="text-2"> 댁으로 </span>
            </div>
          </div>
          <div class="main-banner-applybtn">
            <button
              class="container-1-btn-bottom"
              @click="goEnter()"
              data-aos="fade-up"
            >
              <div class="container-btn-bottom-text">간편 입점 신청</div>
            </button>
            <!--            <button
              class="container-1-btn-bottom mr-0"
              @click="goCheck()"
              data-aos="fade-up"
            >
              <div class="container-btn-bottom-text">입점 내역 조회</div>
            </button>-->
            <button
              @click="posDown()"
              class="container-1-btn-bottom mr-0"
              data-aos="fade-up"
            >
              <div class="container-btn-bottom-text">POS 다운받기</div>
            </button>
          </div>
          <!-- 230130 구분선 태그 추가 -->
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import Post from "@/api/Post";

AOS.init();

export default {
  name: "Home",
  components: {},
  data() {
    return {
      postList: null,
      video: [
        { link: "https://www.youtube.com/embed/LpzaArqnd58" },
        // 230130 택시 youtube link 추가
        { link: "https://www.youtube.com/embed/r3RWHamT_2U" },
        // { link: "https://www.youtube.com/embed/-SzrPM34wyw"},
      ],
    };
  },
  async mounted() {
    console.log(`[check] mounted`);
    let version = await this.getVersion();
    console.log(
      `[check] version:${version}, VUE_APP_VER:${process.env.VUE_APP_VER}`
    );
    version = Number(version);

    if (version && version > Number(process.env.VUE_APP_VER)) {
      this.setVersion();
    }
    this.postList = await this.getPostList();
    //this.formatImg(); //220621 이관작업 후 사용안함
  },
  methods: {
    linkalert: function (message) {
      alert(message);
    },
    setVersion() {
      window.setTimeout("location.reload(true)", 2000); //location.reload(true); jskang 220823: 버전 업데이트 시 원할한 최신 웹 페이지 반영을 위해 수정
    },
    goEnter() {
      if (this.$router.currentRoute.name != "Enter_Info") {
        window.scrollTo(0, 0);
        this.$router.push({ name: "Enter_Info" });
      }
    },
    goFaq() {
      window.open("/faq/index.html");
    },
     goOwner() {
      window.open("https://owner.daeguro.co.kr");
    },
    goCheck() {
      if (this.$router.currentRoute.name != "User_Check") {
        this.$router.push({ name: "User_Check" });
      }
    },
    posDown() {
      window.open(
        "https://pos.daeguro.co.kr:15421/filedown/POS/ThinkPOS_Setup.exe"
      );
    },
    async getPostList() {
      const { data: postList } = await Post.getList();
      return postList.data; // 220621 작업내용 : postList.posts 에서 postList.data 로 수정
      // return postList.posts; // 220621 이관작업 전 기존 소스코드 주석화 - 임시보관
    },
    async getVersion() {
      const { data: version } = await Post.getVersion();
      // console.log(`APP_GBN -> ${version.data.APP_GBN}`);
      // console.log(`APP_VERSION -> ${version.data.APP_VERSION}`);
      // console.log(`MOD_UCODE -> ${version.data.MOD_UCODE}`);
      // console.log(`MOD_DATE -> ${version.data.MOD_DATE}`);
      if (version && version.data.APP_VERSION) {
        return version.data.APP_VERSION;
      } else {
        return null;
      }
    },

    // 220621 이관작업 후 formatImg() 와 b64toBlob() 메소드 사용안함
    // formatImg() {
    //   let blob = null;
    //   if (this.postList) {
    //     this.postList.forEach((post, idx) => {
    //       blob = this.b64toBlob(post.THUMBNAIL_URL, "image/png");
    //       this.postList[idx].THUMBNAIL_URL = URL.createObjectURL(blob);
    //     });
    //   }
    // },
    // b64toBlob(b64toBlob, contentType = "", sliceSize = 512) {
    //   const byteCharacters = atob(b64toBlob);
    //   const byteArrays = [];
    //   for (
    //     let offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     const slice = byteCharacters.slice(offset, offset + sliceSize);
    //     const byteNumbers = new Array(slice.length);
    //     for (let i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }
    //     const byteArray = new Uint8Array(byteNumbers);
    //     byteArrays.push(byteArray);
    //   }
    //   const blob = new Blob(byteArrays, { type: contentType });
    //   return blob;
    // },

    appdownand() {
      // window.open(
      //   "https://play.google.com/store/apps/details?id=com.insungdata.daegudelivery"
      // );
      this.$router.push({ name: "AppDown", params: { type: "android" } });
    },
    appdownios() {
      // window.open("https://apps.apple.com/kr/app/id1572960675");
      this.$router.push({ name: "AppDown", params: { type: "ios" } });
    },
    goLink() {
      window.open("https://biz.daeguro.co.kr/");
    },
    goLinkService() {
      window.open("https://daeguro.co.kr/biz/home/");
    },
  },
  filters: {
    substring: function (str) {
      var maxLength = 25;
      if (str.length < maxLength) {
        return str;
      }
      return str.substring(0, maxLength) + "...";
    },
  },
};
</script>

<style scoped>
.sec-3-con a {
  text-decoration: none;
}
/* 230130 */
img {
  image-rendering: -webkit-optimize-contrast;
}

@media all and (min-width: 1024px) {
  .br-mobile {
    display: none;
  }
  .w-none {
    display: none !important;
  }
  .mb-20 {
    margin-bottom: 20px !important;
  }

  .container-1-font-highlight {
    background-image: url("../assets/imgs/dot.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 65%;
    padding-top: 2.5%;
  }
  .container-1-title-1,
  .container-1-description-1 {
    color: #ffffff;
  }
  /* 230130 */
  .container-1-banner-logo img {
    width: 175px;
  }
  .container-1-description-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.88px;
    text-align: left;
    color: #ffffff;
    padding-top: 14px;
    margin-bottom: 43px;
  }
  /* 230130 line-height 1.18 > 0.8 */
  .container-1-text-1 {
    line-height: 0.8;
    font-size: 60px;
  }
  .container-1-left-content {
    width: 585px;
    height: 100%;
  }
  .container-1-btn {
    width: 5vw;
    margin-right: 35px;
    filter: drop-shadow(3px 3px 8px rgba(0, 0, 0, 0.3));
  }
  /* 230130 width 556 > 532 + margin-top 40 > 56 */
  .container-1-left-content-img {
    float: left;
    width: 560px;
    margin: 74px 0 0 38px;
  }
  .container-1-btn-margin {
    height: 68px;
  }

  /* 자간, 행간 조정 */
  /* 230130 text-align left > center */
  .container-1-title {
    font-family: "NanumSquareNeoBold";
    font-size: 72px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.18;
    letter-spacing: -2.88px;
    text-align: center;
    color: #ffffff;
  }
  /* 230130 */
  .text-1 {
    font-family: "NanumSquareNeoBold";
    letter-spacing: -2.6px;
    font-size: 58px;
  }
  /* 230130 font-family NexonBold > Nexon + letter-spacing -5.6 > -1.4 + font-size 72 > 35 */
  .text-2 {
    font-family: "NanumSquareNeoBold";
    letter-spacing: -1.4px;
    font-size: 33px;
  }
  /* 230130 */
  .text-3 {
    font-family: "NanumSquareNeoExtraBold";
    letter-spacing: -1.6px;
    font-size: 40px;
  }
  /* 230130 display 추가 + margin-top 추가 */
  .main-banner-appbtn {
    overflow: hidden;
    display: inline-block;
    margin-top: 50px;
  }
  .main-banner-appbtn .container-1-btn-top {
    width: 174px;
    height: 47px;
    padding: 7px 0;
    /*margin-bottom: 20px;*/
    border-radius: 24px;
    background-color: #3e3e3e !important;
    box-sizing: border-box;
  }
  .main-banner-appbtn .container-1-btn-top img {
    width: auto;
    height: 34px;
  }
  .main-banner-appbtn .container-1-btn-top.btn-and {
    margin-right: 22px;
  }

  .container-1-btn-text {
    width: 166px;
    height: 23px;
    margin: 5px 0 4px 0;
    font-family: "PretendardMedium";
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: left;
    color: #ffffff;
  }

  .container-1-btn-bottom {
    float: left;
    width: 174px;
    height: 47px;
    padding: 0 0 2px;
    border-radius: 24px;
    border: solid 2px #ffffff;
    margin-right: 22px;
    box-sizing: border-box;
  }
  .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: center;
    color: #ffffff;
    transition: all 0.3s;
  }
  .container-1-btn-bottom:hover .container-btn-bottom-text {
    transition: all 0.3s;
    color: #1fc7ff;
  }
  .container-1-left-content,
  .container-1-right-content {
    float: left;
    width: 50%;
  }
  /* 230130 padding-left 72px > 0 + padding-top 138 > 81 + text-align 추가 */
  .container-1-right-content {
    padding: 81px 0 0 0;
    text-align: center;
  }
  .container-2-img {
    width: 220.2px;
  }
  .container-2-title,
  .container-2-img {
    float: left;
  }
  .container-2-title {
    width: 631px;
    margin-left: 83.8px;
    color: #01caff;
  }

  /*메인배너*/
  .t-con-text {
    display: none;
  }
  /*common.css*/
  .fl {
    float: left !important;
  }
  .fr {
    float: right !important;
  }
  .text-highlight {
    display: inline-block;
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 25% auto;
    padding-top: 0.7%;
  }
  .text-bold {
    font-weight: bold !important;
  }

  /*메인배너*/
  .main-banner-wrap {
    background-color: #01caff;
    height:730px;
  }
  /* 230130 padding 추가 */
  .main-banner-wrap .main-con {
    width: 1280px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    padding: 0 50px;
  }
  /*메인컨텐츠*/
  .real-container .contents-wrap {
    background-color: #f4f4f4;
  }
  .real-container .contents-wrap:nth-child(2n-1) {
    background-color: #ffffff;
  }
  .real-container .contents-wrap:nth-child(2n-1) .contents-main-img {
    float: left;
  }
  /* 230130 */
  .real-container .contents-wrap:nth-child(2n-1) .contents-main-sub-img {
    float: right;
  }
  .real-container .contents-wrap:nth-child(2n-1) .contents-main-text {
    float: right;
  }
  /* 230130 padding-horizontal 160 > 80 */
  .contents-wrap .contents-main {
    width: 1280px;
    margin: 0 auto;
    padding: 50px 80px;
  }
  /* 230130 */
  .sub-sec-2 .contents-wrap .contents-main {
    width: 1280px;
    margin: 0 auto;
    padding: 27px 150px;
  }
  /* 230130 */
  .sub-sec-2 .contents-wrap:first-child .contents-main {
    width: 1280px;
    margin: 0 auto;
    padding: 27px 115px;
  }
  .contents-wrap .contents-reserve {
    padding: 0 !important;
    margin-top: 100px !important;
  }
  .contents-main > div:nth-child(1) {
    float: right;
  }
  .contents-main > div:nth-child(2) {
    float: left;
  }
  /* 230130 width 350 > 382 */
  .contents-main .contents-main-img img {
    width: 382px;
  }
  .contents-main .contents-main-img img.benefit1-image {
    width: 500px;
  }
  /* 230130 */
  .sub-sec-2 .contents-wrap:first-child .contents-main .contents-main-img img {
    width: 541px;
    padding-top: 60px;
  }
  /* 230130 */
  .contents-main .no-bottom-margin img {
    width: auto;
    height: 594px;
    margin: 0 0 -639px 0;
  }
  /* 230130 */
  .sub-sec-1
    .contents-wrap:nth-child(even)
    .contents-main
    .no-bottom-margin
    img {
    width: auto;
    height: 594px;
    margin: 0 50px -639px 0;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img img {
    width: 530px;
  }
  /* 230130 */
  .sub-sec-1
    .contents-wrap:nth-child(even)
    .contents-main
    .contents-main-sub-img
    img {
    width: 530px;
    margin-left: 50px;
  }
  .contents-main .contents-reserve-img {
    text-align: center;
    float: none !important;
  }
  .contents-main .contents-reserve-img img {
    width: 987px;
    margin: 0 0 -7px 0 !important;
  }
  .contents-main .contents-reserve-img .img-reserve-desktop {
    display: inline-block;
  }
  .contents-main .contents-reserve-img .img-reserve-mobile {
    display: none;
  }
  .contents-main .contents-reserve-text {
    font-family: "NanumSquareNeoBold";
    float: none !important;
    text-align: center;
  }
  .contents-main .contents-reserve-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    font-weight: normal;
    font-size: 40px;
    letter-spacing: -0.04em;
  }
  .contents-main .contents-reserve-text .main-context {
    font-family: "Noto Sans";
    font-weight: normal;
    font-size: 22px;
  }
  .contents-main .contents-reserve-text .main-headtext .font-highlight {
    font-family: "NanumSquareNeoBold";
    color: #1fcaff;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img {
    width: 530px;
    padding: 80px 0 40px 0;
  }
  /* 230130 width 473 > 447 */
  .contents-main .contents-main-text {
    font-family: "PretendardMedium";
    width: 447px;
    padding: 183px 0 150px 0;
  }
  .contents-main .contents-main-text .main-headtit {
    font-family: "PretendardMedium";
    display: inline-block;
    background: linear-gradient(104deg, #00ffff -4%, #0093ff 102%);
    border-radius: 21px;
    letter-spacing: -0.54px;
    font-weight: 350;
    font-size: 18px;
    color: #fff;
    padding: 5px 16px;
    margin-bottom: 26px;
  }
  .contents-main .contents-main-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-weight: normal;
    font-size: 40px;
    color: #1fcaff;
    margin-bottom: 28px;
  }
  /* 230130 color 5c5c5c > 000000 */
  .contents-main .contents-main-text .main-context {
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 22px;
    color: #000000;
    margin-bottom: 0;
  }
  /* 230130 */
  .contents-main .contents-main-text .sub-context {
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 15px;
    color: #5c5c5c;
    margin-bottom: 0;
    padding-top: 10px;
  }
  /*하단배너*/
  .container-con {
    overflow: hidden;
  }
  .container-wrap .container-con-appdown {
    overflow: hidden;
    width: 932px;
    margin: 0 auto;
    padding: 212px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
  .container-con-appdown .con-left {
    float: left;
    margin: 26px 0 0 0;
  }
  .container-con-appdown .con-left img {
    width: 220px;
    height: auto;
  }
  .container-con-appdown .con-right {
    float: right;
  }
  .container-con-appdown .con-right p {
    color: #01caff;
  }
  .container-con-appdown .con-right p:nth-child(1) {
    font-family: "NanumSquareNeoBold";
    font-weight: bold;
    line-height: 1.16;
    letter-spacing: -3.3px;
    font-size: 55px;
    margin-bottom: 16px;
  }
  .container-con-appdown .con-right p:nth-child(2) {
    font-family: "NanumSquareNeoBold";
    font-weight: normal;
    line-height: 1.14;
    letter-spacing: -1.68px;
    font-size: 28px;
    margin-bottom: 42px;
  }
  .m-con-text {
    display: none;
  }
  .container-con-appdown .con-right .appdown-btn {
    overflow: hidden;
  }
  .appdown-btn .container-1-btn-top {
    background-color: #1fcaff;
  }

  /*하단배터 버튼 추가*/
  .container-con-appdown .container-1-btn-bottom {
    border: solid 2px #3e3e3e !important;
    color: #3e3e3e !important;
  }
  .container-con-appdown .container-1-btn-bottom:hover {
    border: solid 2px #1fcaff !important;
    color: #1fcaff !important;
    transition: all 0.3s;
  }
  .container-con-appdown .container-1-btn-bottom a {
    text-decoration: none;
  }
  .container-con-appdown .container-1-btn-bottom a .container-btn-bottom-text {
    font-family: "PretendardMedium";
    text-decoration: none;
    color: #3e3e3e !important;
  }
  .container-con-appdown
    .container-1-btn-bottom:hover
    a
    .container-btn-bottom-text {
    color: #1fcaff !important;
    transition: all 0.3s;
  }

  /*추가*/
  .contents-wrap.sec-1 .contents-main {
    padding: 78px 176px 0 !important;
  }
  .sec-tit {
    margin-bottom: 68px;
    font-family: "NanumSquareNeoBold";
    line-height: 1.45;
    letter-spacing: -1.2px;
    text-align: center;
    font-size: 40px;
    color: #1fcaff;
  }
  /* 230130 color 333333 > 666666 */
  .sec-sub-tit {
    font-family: "PretendardMedium";
    letter-spacing: -0.88px;
    text-align: center;
    font-size: 22px;
    color: #666666;
  }
  /* 230130 740 > 100% */
  .sec-1 .sec-1-con {
    float: inherit !important;
    width: 100%;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con .sec-1-img {
    overflow: hidden;
    text-align: center;
  }
  /* 230130 width 646 > 900 + margin-bottom -5 > -7 */
  .sec-1 .sec-1-con img {
    width: 900px;
    height: auto;
    margin: -5px 10px -7px 0;
  }
  .sec-1 .sec-1-con .img-cover img {
    display: none;
  }
  .sec-1 .sec-1-con .sec-1-tit {
    font-family: "NanumSquareNeoBold";
    margin-bottom: 54px !important;
    text-align: center;
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-size: 40px;
    color: #1fcaff;
  }
  .sec-1 .sec-1-con ul {
    list-style: none;
    padding: 0;
    margin-bottom: 15px;
  }
  /* 230130 width 33.333 > 25 */
  .sec-1 .sec-1-con ul li {
    display: inline-block;
    width: 25%;
    box-sizing: border-box;
    position: relative;
  }
  .sec-1 .sec-1-con .sec-1-text {
    font-family: "PretendardMedium";
    float: initial !important;
    width: 178px;
    background: #fff;
    border-radius: 20px;
    padding: 16px 22px;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con .sec-1-text b {
    font-family: "PretendardMedium";
    margin-bottom: 6px;
    line-height: 1.55;
    letter-spacing: -0.88px;
    font-size: 22px;
    color: #4e4e4e;
  }
  .sec-1 .sec-1-con .sec-1-text span {
    font-family: "PretendardMedium";
    line-height: 1.5;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 20px;
    color: #5c5c5c;
  }
  .sec-1 .sec-1-con ul li .text-cover {
    float: initial;
    text-align: center;
  }
  .sec-1 .sec-1-con ul li::after {
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    border: 20px solid transparent;
    border-bottom-width: 0;
    border-top-color: #fff;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
  }
  .sec-1 .sec-1-con .sec-1-text span {
    display: block;
  }
  .sec-2 {
    background-color: #1fcaff !important;
  }
  .sec-2 .contents-main {
    width: 1280px;
    padding: 90px 130px;
    margin: 0 auto;
  }
  .sec-2 .contents-main .sec-2-con {
    float: inherit !important;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit {
    font-family: "NanumSquareNeoBold";
    text-align: center;
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-size: 40px;
    margin-bottom: 65px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit .font-highlight {
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 85%;
    padding-top: 1.4%;
  }
  .sec-2 .contents-main .sec-2-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
  }
  .sec-2 .contents-main .sec-2-con ul li {
    width: 33%;
    display: inline-block;
  }
  .sec-2 .contents-main .sec-2-con ul li:last-child {
      padding-bottom: 0;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text {
    font-family: "GmarketSansBold";
    display: block;
    width: 178px;
    height: 178px;
    background: #fff;
    border-radius: 50%;
    padding: 65px 0;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    font-weight: bold;
    font-size: 62px;
    margin: 0 auto 43px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text span {
    font-family: "GmarketSansBold";
    display: inline-block;
    font-weight: bold;
    font-size: 25px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li b {
    font-family: "PretendardBold";
    display: block;
    margin-bottom: 26px;
    text-align: center;
    font-size: 26px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con ul li span {
    font-family: "PretendardMedium";
    display: block;
    line-height: 1.64;
    letter-spacing: -0.88px;
    text-align: center;
    font-size: 22px;
    font-weight: 350;
    color: #fff;
  }
  .sec-3 {
    width: 100%;
    background-color: #f4f4f4 !important;
  }
  .sec-3 .contents-main {
    width: 1280px;
    padding: 130px;
    margin: 0 auto;
  }
  .sec-3 .contents-main .sec-3-con {
    float: inherit !important;
  }
  .sec-3 .contents-main .sec-3-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
  }
  .sec-3 .contents-main .sec-3-con ul li {
    width: 25%;
    height: 328px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic {
    display: block;
    background: #ffffff;
    width: 224px;
    height: 224px;
    margin-bottom: 35px;
    overflow: hidden;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1);
    -webkit-transform: scale(1);
    transition: all 0.3s;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transition: all 0.3s;
  }
  /* 230130 color 5c5c5c > 000000 */
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-text {
    font-family: "PretendardMedium";
    display: block;
    width: 224px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 22px;
    transition: all 0.3s;
    color: #000000;
    text-align: center;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-text {
    color: #1fc7ff;
    transition: all 0.3s;
  }

  .sec-4 {
    width: 100%;
    background-color: #ffffff !important;
  }
  .sec-4 .contents-main {
    width: 1280px;
    padding: 90px 150px;
    margin: 0 auto;
  }
  .sec-4 .contents-main .sec-4-con {
    float: inherit !important;
  }
  .sec-4 .contents-main .sec-4-con .sec-tit {
    margin-bottom: 10px;
  }
  /* 230130 margin-bottom 42px > 80px */
  .sec-4 .contents-main .sec-4-con .sec-4-video {
    background: #ffffff;
    margin: 42px auto 80px auto;
    text-align: center;
  }
  /* 230130 */
  .sec-4 .contents-main .sec-4-con .sec-4-video iframe {
    width: 800px;
    height: 450px;
  }
  .sec-4 .contents-main .sec-4-con .sec-4-video .daegu-m4 {
    width: 800px;
  }
  .sec-4 .contents-main .sec-4-con ul {
    padding: 0 0 5px;
    list-style: none;
    text-align: center;
  }
  .sec-4 .contents-main .sec-4-con ul li {
    display: inline-block;
    margin: 0 11px;
  }
  .sec-4 .contents-main .sec-4-con ul li button {
    border-radius: 24px;
    width: 174px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios {
    background-color: #3e3e3e !important;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and img,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios img {
    width: auto;
    height: 34px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b {
    border: solid 2px #3e3e3e;
    font-family: "PretendardMedium";
    text-decoration: none;
    letter-spacing: -1.2px;
    line-height: 1;
    font-weight: 300;
    font-size: 20px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b:hover {
    border: solid 2px #1fc7ff;
    color: #1fc7ff;
    transition: all 0.3s;
  }
  /*앱다운로드*/
  .main-banner-w {
    float: left;
    width: auto;
  }
  .main-banner-w p {
    font-family: "PretendardBold";
    letter-spacing: -0.56px;
    font-weight: bold;
    font-size: 14px;
    color: #3e3e3e;
  }
  .main-banner-w img {
    width: 114px;
    height: 110px;
  }
  /* 230130 text-align 추가 */
  .main-banner-w.main-banner-l {
    padding-right: 26px;
    text-align: left;
  }
  /* 230130 width 174 > 222 + text-align 추가 */
  .main-banner-w.main-banner-r {
    width: 222px;
    padding-left: 26px;
    text-align: left;
  }
  .main-banner-appbtn
    .main-banner-w.main-banner-r
    .container-1-btn-top.btn-and {
    margin-bottom: 16px;
  }

  .btn-row {
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px; /* 버튼 간격 */
  }
  .container-btn-img-bottom,
  .container-btn-img-bottom-white {
    font-family: "PretendardMedium";
    transition: all 0.3s;
    border-radius: 24px;
    padding: 6px 24px;
    width: 186px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .container-btn-img-bottom {
    background: #3e3e3e 0% 0% no-repeat padding-box;
    border: none;
  }
  .container-btn-img-bottom-white {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: #333333 solid 1px;
  }
  .container-btn-img-bottom-text,
  .container-btn-img-bottom-text-black {
    text-align: center;
    font: normal normal normal 20px/27px PretendardMedium;
    letter-spacing: -1.08px;
    opacity: 1;
  }
  .container-btn-img-bottom-text {
    color: #ffffff;
  }
  .container-btn-img-bottom-text-black {
    color: #000000;
  }

}

@media all and (min-width: 768px) and (max-width: 1023px) {
  .br-mobile {
    display: none;
  }
  .t-none {
    display: none !important;
  }
  .container {
    width: 1170px !important;
  }
  .container-1 {
    background-color: #01caff;
    height: 730px;
  }
  .container-1-container {
    height: 100%;
  }
  .row-1 {
    height: 100%;
  }
  .container-1-font-highlight {
    background-image: url("../assets/imgs/dot.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 60%;
    padding-top: 3%;
  }
  .container-2-font-highlight {
    background-image: url("../assets/imgs/blue_dot2.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 30%;
    padding-top: 3%;
  }

  .container-1-title-1,
  .container-1-description-1 {
    color: #ffffff;
  }
  .container-1-description-1 {
    font-size: 23px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.52;
    letter-spacing: -0.92px;
    text-align: left;
    color: #ffffff;
    padding-top: 20px;
    margin-bottom: 54px;
  }
  .btn-container-1-text-1 {
    font-size: 1.2vw;
  }
  .container-1-layout {
    height: 100%;
    /* height: calc(100% - 90px);
  height: -webkit-calc(100% - 90px);
  height: -moz-calc(100% - 90px);
  height: -o-calc(100% - 90px); */
  }
  /* 230130 */
  .container-1-banner-logo {
    line-height: 0.8;
  }
  /* 230130 */
  .container-1-banner-logo img {
    width: 175px;
  }
  /* 230130 padding-top 17px > 0 + line-height 추가 */
  .container-1-title-1 {
    padding-top: 0;
    line-height: 1.8;
  }
  .container-1-text-1 {
    font-size: 64px;
  }

  .logo {
    height: 90px;
  }
  .container-1-left-content {
    width: 585px;
    height: 100%;
  }

  .container-1-btn {
    width: 5vw;
    margin-right: 35px;
    filter: drop-shadow(3px 3px 8px rgba(0, 0, 0, 0.3));
  }

  .container-1-btn-margin {
    height: 68px;
  }

  /* 자간, 행간 조정 */
  /* 230130 padding-top 117px > 0 + font-family Noto Sans KR > NexonBold + font-size 72 > 60 */
  .container-1-title {
    padding-top: 0;
    font-family: "NanumSquareNeoBold";
    font-size: 60px;
    /* font-weight: bold; */
    font-stretch: normal;
    font-style: normal;
    line-height: 1.18;
    letter-spacing: -2.88px;
    text-align: left;
    color: #ffffff;
  }
  /* 230130 font-family NexonBold > Nexon + font-size 52 > 36 + letter-spacing -2.08 > -1.44 */
  .text-2 {
    font-family: "NanumSquareNeoBold";
    letter-spacing: -1.44px;
    font-size: 36px;
  }
  /* 230130 */
  .text-3 {
    font-family: "NanumSquareNeoExtraBold";
    letter-spacing: -1.68px;
    font-size: 42px;
  }

  .main-banner-appbtn {
    overflow: hidden;
    height: 47px;
    margin-top: 40px;
  }
  .main-banner-appbtn .container-1-btn-top {
    width: 174px;
    height: 47px;
    padding: 7px 0;
    margin-bottom: 20px;
    border-radius: 24px;
    background-color: #3e3e3e;
    box-sizing: border-box;
  }
  .main-banner-appbtn .container-1-btn-top img {
    width: auto;
    height: 34px;
  }
  .main-banner-appbtn .container-1-btn-top.btn-and {
    margin-right: 22px;
  }

  .container-1-btn-text {
    width: 166px;
    height: 23px;
    margin: 5px 0 4px 0;
    font-family: "PretendardMedium";
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: left;
    color: #ffffff;
  }

  .container-1-btn-bottom {
    float: left;
    width: 174px;
    height: 47px;
    /* margin: 20px 5px 0 22px; */
    padding: 13px 28px 11px;
    border-radius: 24px;
    border: solid 2px #ffffff;
    margin-right: 22px;
    box-sizing: border-box;
  }
  .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 19px;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: left;
    color: #ffffff;
  }
  .container-1-left-content,
  .container-1-right-content {
    float: left;
  }
  .container-2-img {
    width: 220.2px;
  }
  /*.container-2-title,*/
  /*.container-2-img {*/
  /*  float: left;*/
  /*}*/
  .container-2-title {
    width: 631px;
    margin-left: 83.8px;
    color: #01caff;
    /* font-family: ; */
  }

  /*main.css*/
  /*common.css*/
  .fl {
    float: left !important;
  }
  .fr {
    float: right !important;
  }
  .text-highlight {
    display: inline-block;
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 7px auto;
    padding-top: 10px;
  }
  .text-bold {
    font-weight: bold !important;
  }

  /*메인배너*/
  .main-banner-wrap {
    background-color: #01caff;
    /*height: 730px;*/
  }
  .main-banner-wrap .main-con {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
  }
  /*메인컨텐츠*/
  .real-container .contents-wrap {
    background-color: #f4f4f4;
  }
  .real-container .contents-wrap:nth-child(2n-1) {
    background-color: #fff !important;
  }
  .real-container .contents-wrap:nth-child(2n-1) .contents-main-img {
    float: left;
  }
  .real-container .contents-wrap:nth-child(2n-1) .contents-main-text {
    float: right;
  }
  .contents-wrap .contents-main {
    width: 1170px;
    margin: 0 auto;
    padding: 80px 140px;
  }
  .contents-wrap .contents-reserve {
    padding: 0 !important;
    margin-top: 100px !important;
  }
  .contents-main > div:nth-child(1) {
    float: right;
  }
  .contents-main > div:nth-child(2) {
    float: left;
  }
  .contents-main .contents-main-img img {
    width: 350px;
  }
  .contents-main .contents-reserve-img {
    text-align: center;
    float: none !important;
  }
  .contents-main .contents-reserve-img img {
    width: 90%;
    margin: 0 0 -7px 0 !important;
  }
  .contents-main .contents-reserve-img .img-reserve-desktop {
    display: inline-block;
  }
  .contents-main .contents-reserve-img .img-reserve-mobile {
    display: none;
  }
  .contents-main .contents-reserve-text {
    font-family: "NanumSquareNeoBold";
    float: none !important;
    text-align: center;
  }
  .contents-main .contents-reserve-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    font-weight: normal;
    font-size: 40px;
    letter-spacing: -0.04em;
  }
  .contents-main .contents-reserve-text .main-context {
    font-family: "Noto Sans";
    font-weight: normal;
    font-size: 22px;
  }
  .contents-main .contents-reserve-text .main-headtext .font-highlight {
    font-family: "NanumSquareNeoBold";
    color: #1fcaff;
  }
  .contents-main .contents-main-text {
    font-family: "PretendardMedium";
    width: 473px;
  }

  /*하단배너*/
  .container-con {
    overflow: hidden;
  }
  .container-wrap .container-con-appdown {
    width: 1170px;
    margin: 0 auto;
    padding: 239px 0;
  }
  .container-con-appdown .con-left {
    float: left;
    padding: 0 80px 0 117px;
    margin-right: 80px;
    margin-top: 20px;
  }
  .container-con-appdown .con-left img {
    width: 220px;
    height: auto;
  }
  .container-con-appdown .con-right {
    float: right;
  }
  .container-con-appdown .con-right p {
    color: #01caff;
  }
  .container-con-appdown .con-right p:nth-child(1) {
    font-family: "NanumSquareNeoBold";
    line-height: 1.16;
    letter-spacing: -3.3px;
    font-size: 55px;
    margin-bottom: 16px;
  }
  .container-con-appdown .con-right p:nth-child(2) {
    font-family: "NanumSquareNeoBold";
    line-height: 1.14;
    letter-spacing: -1.68px;
    font-size: 28px;
    margin-bottom: 42px;
  }
  .m-con-text,
  .t-con-text {
    display: none;
  }
  .container-con-appdown .con-right .appdown-btn {
    overflow: hidden;
    height: auto;
  }
  .appdown-btn .container-1-btn-top {
    background-color: #1fcaff;
  }

  /*새로적용*/
  /*메인배너*/
  .main-banner-wrap {
    background-color: #1fcaff;
  }
  .t-con-text .container-1-left-content {
    float: none;
    display: block;
  }
  /* 230130 margin-top 25 > 32 + width, height 주석처리 */
  .container-1-left-content {
    display: none;
    /* width: 521px; */
    /* height: 656px; */
    margin: 32px auto -13px auto;
    overflow: hidden;
  }
  /* 230130 width 520 > 459 + margin-top 25px > 0 */
  .container-1-left-content img {
    width: 459px;
    margin-top: 0;
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top {
    background-color: #3e3e3e;
    padding: 8px 0;
    margin-bottom: 0;
    /*line-height: 47px;*/
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top img {
    vertical-align: top;
  }
  .t-con-text .main-banner-applybtn .container-1-btn-bottom {
    display: none;
    float: none;
    width: 174px;
    height: 47px;
    padding: 12px 0;
    border-radius: 24px;
    border: solid 2px #ffffff;
    margin-right: 22px;
    box-sizing: border-box;
  }
  .t-con-text .main-banner-applybtn .container-1-btn-bottom a {
    text-decoration: none;
  }
  .t-con-text .main-banner-applybtn .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 20px;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: center;
    color: #ffffff;
  }

  /*메인컨텐츠*/
  .real-container .contents-wrap:nth-child(2n-1) {
    background-color: #f4f4f4;
  }
  .contents-wrap .contents-main {
    width: 100%;
    margin: 0 auto;
    padding: 28px 0 80px 0;
  }
  /* 230130 */
  .sub-sec-1 .contents-wrap .contents-main {
    width: 100%;
    margin: 0 auto;
    padding: 50px 0 100px 0;
  }
  .contents-main div:nth-child(1) {
    float: none !important;
    width: 100%;
  }
  .contents-main div:nth-child(2) {
    float: none !important;
    width: 100%;
  }
  .contents-main .contents-main-img {
    float: none !important;
    width: 100%;
    text-align: center;
  }
  .contents-main .contents-main-img img {
    width: auto;
    height: 642px;
  }
  /* 230130 */
  .sub-sec-2 .contents-wrap:first-child .contents-main .contents-main-img img {
    width: auto;
    height: 587px;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img {
    float: none !important;
    width: 100%;
    text-align: center;
    padding-top: 80px;
  }
  /* 230130 */
  .contents-main .no-bottom-margin img {
    width: auto;
    height: 594px;
    margin: 0 90px 0 0;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img img {
    width: auto;
    height: 480px;
  }
  .contents-main .contents-main-text {
    font-family: "PretendardMedium";
    float: none !important;
    text-align: center;
  }
  .contents-main .contents-main-text .main-headtit {
    font-family: "PretendardMedium";
    display: inline-block;
    background: linear-gradient(104deg, #00ffff -4%, #0093ff 102%);
    padding: 4px 16px;
    margin: 0 0 26px;
    border-radius: 21px;
    letter-spacing: -0.54px;
    white-space: nowrap;
    font-weight: 350;
    font-size: 18px;
    color: #fff;
  }
  .contents-main .contents-main-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-weight: normal;
    font-size: 40px;
    color: #1fcaff;
    margin-bottom: 28px;
  }
  /* 230130 color 5c5c5c > 000000 */
  .contents-main .contents-main-text .main-context {
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 22px;
    color: #000000;
    margin-bottom: 0;
  }
  /* 230130 */
  .contents-main .contents-main-text .sub-context {
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 22px;
    color: #5c5c5c;
    margin-bottom: 0;
    padding-top: 10px;
  }
  /*하단배너*/
  .container-con {
    overflow: hidden;
  }
  .container-wrap .container-con-appdown {
    width: 100%;
    margin: 0 auto;
    padding: 230px 0;
  }
  .container-con-appdown .con-left {
    float: none;
    padding: 0;
    margin: 0 0 52px;
    text-align: center;
  }
  .container-con-appdown .con-left img {
    width: 224px;
    height: auto;
  }
  .container-con-appdown .con-right {
    float: none;
    text-align: center;
  }
  .container-con-appdown .con-right p {
    font-family: "PretendardMedium";
    color: #01caff;
  }
  .container-con-appdown .con-right p:nth-child(1) {
    font-weight: bold;
    line-height: 1.16;
    letter-spacing: -2.58px;
    font-size: 43px;
    margin-bottom: 19px;
  }
  .container-con-appdown .con-right p:nth-child(2) {
    line-height: 1.16;
    letter-spacing: -1px;
    font-weight: normal;
    font-size: 25px;
    margin-bottom: 60px;
  }
  .m-con-text,
  .container-1-right-content {
    display: none;
  }
  /* 230130 padding-top 64 > 40 */
  .t-con-text {
    display: block;
    padding-top: 40px;
    line-height: 1.18;
    letter-spacing: -1.6px;
    text-align: center;
    font-weight: bold;
    font-size: 53px;
    color: #ffffff;
  }
  /* 230130 display inline-block > block + text-align 추가 */
  .t-con-text > div > div {
    display: block;
    margin: 0 7px;
    text-align: center;
  }
  .t-con-text .container-1-text-1 {
    font-family: "NanumSquareNeoBold";
    font-weight: normal;
    font-size: 43px;
  }
  .t-con-text .font-highlight {
    background-image: url("../assets/imgs/dot.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 30px auto;
    padding-top: 12px;
  }
  .t-con-text p {
    font-family: "Kopup";
    margin: 16px 0 0;
    line-height: 1.56;
    letter-spacing: -0.72px;
    font-weight: 500;
    font-size: 18px;
  }
  .text-highlight {
    background-image: url("../assets/imgs/blue_dot2.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 8px auto;
    padding-top: 6px;
  }
  .text-bold {
    font-weight: bold;
  }
  .main-banner-appbtn .container-1-btn-top {
    width: 174px;
    height: 47px;
    padding: 7px 0;
    margin-bottom: 20px;
    border-radius: 24px;
    background-color: #3e3e3e;
    box-sizing: border-box;
  }
  .main-banner-appbtn .container-1-btn-top img {
    width: auto;
    height: 34px;
  }
  .main-banner-appbtn .container-1-btn-top.btn-and {
    margin-right: 22px;
  }
  .container-con-appdown .con-right .btn-googleplay {
    background: url("../assets/imgs/btn_gooleplay.png") no-repeat center center;
    display: block;
    width: 184px;
    height: 47px;
  }
  /*하단배터 버튼 추가*/
  .container-con-appdown .container-1-btn-bottom {
    float: none;
    width: 174px;
    height: 47px;
    padding: 7px 0;
    border-radius: 24px;
    margin-right: 22px;
    box-sizing: border-box;
    border: solid 2px #3e3e3e !important;
    color: #3e3e3e !important;
  }
  .container-con-appdown .container-1-btn-bottom:hover {
    border: solid 2px #1fcaff !important;
    color: #1fcaff !important;
    transition: all 0.3s;
  }
  .container-con-appdown .container-1-btn-bottom a {
    text-decoration: none;
  }
  .container-con-appdown .container-1-btn-bottom .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 20px;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: center;
    color: #3e3e3e;
  }
  .container-con-appdown
    .container-1-btn-bottom:hover
    .container-btn-bottom-text {
    color: #1fcaff !important;
    transition: all 0.3s;
  }
  /*추가*/
  .contents-wrap.sec-1 .contents-main {
    padding: 80px 0 60px !important;
  }
  .sec-tit {
    margin-bottom: 54px;
    font-family: "NanumSquareNeoBold";
    line-height: 1.45;
    letter-spacing: -1.2px;
    text-align: center;
    font-size: 40px;
    color: #1fcaff;
  }
  /* 230130 color 333333 > 666666 */
  .sec-sub-tit {
    font-family: "PretendardMedium";
    letter-spacing: -0.88px;
    text-align: center;
    font-size: 22px;
    color: #666666;
  }
  .sec-1 .sec-1-con {
    float: initial !important;
    width: 100%;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con .sec-1-img {
    overflow: hidden;
    text-align: center;
  }
  .sec-1 .sec-1-con .sec-1-img img {
    display: none;
  }
  .sec-1 .sec-1-con .sec-1-tit {
    font-family: "NanumSquareNeoBold";
    margin-bottom: 30px !important;
    text-align: center;
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-size: 40px;
    color: #1fcaff;
  }
  .sec-1 .sec-1-con ul {
    list-style: none;
    padding: 0;
    margin-bottom: 15px;
  }
  .sec-1 .sec-1-con ul li {
    display: block;
    width: 595px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con ul li .img-cover {
    float: left !important;
    width: 50%;
    text-align: center;
  }
  .sec-1 .sec-1-con ul li img {
    width: 232px;
  }
  /* 230130 2 > odd */
  .sec-1 .sec-1-con ul li:nth-child(even) .img-cover {
    float: right !important;
  }
  .sec-1 .sec-1-con ul li .text-cover {
    float: right !important;
    width: 50%;
    padding: 55px 0;
  }
  .sec-1 .sec-1-con .sec-1-text {
    float: initial !important;
    width: 210px;
    background: #fff;
    border-radius: 20px;
    padding: 12px 24px;
    position: relative;
    margin: 0 auto;
  }
  /* 230130 2 > 2n */
  .sec-1 .sec-1-con ul li:nth-child(2n) .text-cover {
    float: left !important;
  }
  .sec-1 .sec-1-con .sec-1-text b {
    font-family: "PretendardMedium";
    margin-bottom: 6px;
    letter-spacing: -0.88px;
    font-size: 22px;
    color: #4e4e4e;
  }
  .sec-1 .sec-1-con .sec-1-text span {
    font-family: "PretendardMedium";
    line-height: 1.55;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 22px;
    color: #5c5c5c;
  }
  .sec-1 .sec-1-con ul li .sec-1-text::after {
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    border: 20px solid transparent;
    border-left-width: 0;
    border-right-color: #fff;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
  /* 230130 2 > 2n */
  .sec-1 .sec-1-con ul li:nth-child(2n) .sec-1-text::after {
    border-left-width: 20px;
    border-right-width: 0;
    border-left-color: #fff;
    left: initial;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
  .sec-1 .sec-1-con .sec-1-text span {
    display: block;
  }
  .sec-2 {
    background-color: #1fcaff !important;
  }
  .sec-2 .contents-main {
    padding: 80px 0;
  }
  .sec-2 .contents-main .sec-2-con {
    float: initial !important;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit {
    font-family: "NanumSquareNeoBold";
    text-align: center;
    line-height: 1.45;
    letter-spacing: -1.2px;
    font-size: 40px;
    margin-bottom: 50px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit .font-highlight {
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 90%;
    padding-top: 2%;
  }
  .sec-2 .contents-main .sec-2-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
    width: 570px;
    margin: 0 auto;
  }
  .sec-2 .contents-main .sec-2-con ul li {
    width: 100%;
    display: inline-block;
  }
  .sec-2 .contents-main .sec-2-con ul li:nth-child(1),
  .sec-2 .contents-main .sec-2-con ul li:nth-child(2) {
    margin-bottom: 35px;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text {
    font-family: "GmarketSansBold";
    display: block;
    width: 180px;
    height: 180px;
    background: #fff;
    border-radius: 50%;
    padding: 70px 0;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    font-weight: bold;
    font-size: 50px;
    margin: 0 auto 20px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text span {
    font-family: "GmarketSansBold";
    display: inline-block;
    font-weight: bold;
    font-size: 25px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li b {
    font-family: "PretendardBold";
    display: block;
    margin-bottom: 16px;
    text-align: center;
    font-size: 26px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con ul li span {
    font-family: "PretendardMedium";
    display: block;
    line-height: 1.64;
    letter-spacing: -0.88px;
    text-align: center;
    font-size: 22px;
    font-weight: 350;
    color: #fff;
  }
  .sec-3 {
    width: 100%;
    background-color: #f4f4f4 !important;
  }
  .sec-3 .contents-main {
    padding: 98px 130px;
  }
  .sec-3 .contents-main .sec-3-con {
    float: inherit !important;
  }
  .sec-3 .contents-main .sec-3-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
    width: 570px;
    margin: 0 auto;
  }
  .sec-3 .contents-main .sec-3-con ul li {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
  }
  .sec-3 .contents-main .sec-3-con ul li:nth-child(1),
  .sec-3 .contents-main .sec-3-con ul li:nth-child(2) {
    margin-bottom: 48px;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic {
    display: block;
    background: #ffffff;
    width: 224px;
    height: 224px;
    margin: 0 auto 34px;
    overflow: hidden;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1);
    -webkit-transform: scale(1);
    transition: all 0.3s;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transition: all 0.3s;
  }
  /* 230130 color 5c5c5c > 000000 */
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-text {
    display: block;
    margin: 0 auto;
    width: 224px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    line-height: 1.64;
    letter-spacing: -0.88px;
    font-weight: 350;
    font-size: 21px;
    transition: all 0.3s;
    color: #000000;
    text-align: center;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-text {
    color: #1fc7ff;
    transition: all 0.3s;
  }
  .sec-4 {
    width: 100%;
    background-color: #ffffff !important;
  }
  .sec-4 .contents-main {
    padding: 98px 0;
  }
  .sec-4 .contents-main .sec-4-con {
    float: inherit !important;
  }
  .sec-4 .contents-main .sec-4-con .sec-tit {
    margin-bottom: 10px;
  }
  /* 230130 position 추가 + width 추가 + margin-bottom 42px > 80px */
  .sec-4 .contents-main .sec-4-con .sec-4-video {
    background: #ffffff;
    margin: 42px auto 80px auto;
    text-align: center;
    position: relative;
    width: 90%;
  }
  /* 230130 */
  .sec-4 .contents-main .sec-4-con .sec-4-video iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  /* 230130 */
  .iframe16To9 {
    padding-top: 50.6%;
  }
  .sec-4 .contents-main .sec-4-con .sec-4-video .daegu-m4 {
    width: 544px;
  }
  .sec-4 .contents-main .sec-4-con ul {
    width: 408px;
    padding: 0;
    list-style: none;
    text-align: center;
    margin: 0 auto;
  }
  .sec-4 .contents-main .sec-4-con ul li {
    display: inline-block;
    margin: 0 15px;
  }
  .sec-4 .contents-main .sec-4-con ul li:nth-child(1),
  .sec-4 .contents-main .sec-4-con ul li:nth-child(2) {
    margin-bottom: 30px;
  }
  .sec-4 .contents-main .sec-4-con ul li button {
    border-radius: 24px;
    width: 174px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios {
    background-color: #3e3e3e !important;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and img,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios img {
    width: auto;
    height: 34px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b {
    border: solid 2px #3e3e3e;
    font-family: "PretendardMedium";
    text-decoration: none;
    letter-spacing: -1.2px;
    line-height: 0;
    font-weight: 300;
    font-size: 20px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b:hover {
    border: solid 2px #1fc7ff;
    color: #1fc7ff;
    transition: all 0.3s;
  }
  
  .btn-row {
    position: absolute;
    bottom: -70px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
  }
  .container-btn-img-bottom,
  .container-btn-img-bottom-white {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "PretendardMedium";
    transition: all 0.3s;
    border-radius: 24px;
    padding: 6px 24px;
    width: 186px;
    height: 48px;
    cursor: pointer;
  }
  .container-btn-img-bottom {
    background: #3e3e3e 0% 0% no-repeat padding-box;
    border: none;
  }
  .container-btn-img-bottom-white {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: #333333 solid 1px;
  }
  .container-btn-img-bottom-text,
  .container-btn-img-bottom-text-black {
    text-align: center;
    font: normal normal normal 20px/27px PretendardMedium;
    letter-spacing: -1.08px;
    opacity: 1;
  }
  .container-btn-img-bottom-text {
    color: #ffffff;
  }
  .container-btn-img-bottom-text-black {
    color: #000000;
  }
}

@media all and (max-width: 767px) {
  .br-mobile {
    display: block;
  }
  .m-none {
    display: none !important;
  }
  /*메인배너*/
  .main-banner-wrap {
    background-color: #1fcaff;
  }
  .t-con-text .container-1-left-content {
    display: block;
  }
  .container-1-left-content {
    display: none;
    width: 521px;
    margin: 22px auto 0;
    overflow: hidden;
  }
  .container-1-left-content img {
    width: 512px;
    margin-bottom: -15px;
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top {
    background-color: #3e3e3e;
    padding: 0;
    margin-bottom: 0;
    line-height: 47px;
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top img {
    line-height: 47px;
  }
  .t-con-text .main-banner-applybtn .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 19px;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: -1.2px;
    text-align: left;
    color: #ffffff;
  }

  /*메인컨텐츠*/
  .real-container .contents-wrap:nth-child(2n-1) {
    background-color: #f4f4f4;
  }
  .contents-wrap .contents-main {
    width: 100%;
    margin: 0 auto;
    padding: 50px 0 100px;
  }
  .contents-wrap .contents-reserve {
    padding: 0 !important;
    margin-top: 50px !important;
  }
  .contents-main div:nth-child(1) {
    float: none !important;
    width: 100%;
  }
  .contents-main div:nth-child(2) {
    float: none !important;
    width: 100%;
  }
  .contents-main .contents-main-img {
    float: none !important;
    width: 100%;
    text-align: center;
  }
  .contents-main .contents-main-img img {
    width: 350px;
  }
  .contents-main .contents-reserve-img {
    text-align: center;
    float: none !important;
  }
  .contents-main .contents-reserve-img img {
    width: 70%;
    margin: 0 0 -7px 30px !important;
  }
  .contents-main .contents-reserve-img .img-reserve-desktop {
    display: none;
  }
  .contents-main .contents-reserve-img .img-reserve-mobile {
    display: inline-block;
  }
  .contents-main .contents-reserve-text {
    font-family: "NanumSquareNeoBold";
    float: none !important;
    text-align: center;
  }
  .contents-main .contents-reserve-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    font-weight: normal;
    font-size: 28px;
    letter-spacing: -0.04em;
  }
  .contents-main .contents-reserve-text .main-context {
    font-family: "Noto Sans";
    font-weight: normal;
    font-size: 18px;
    letter-spacing: -0.04em;
    line-height: 1.7;
  }
  .contents-main .contents-reserve-text .main-headtext .font-highlight {
    font-family: "NanumSquareNeoBold";
    color: #1fcaff;
  }
  .contents-main .contents-main-text {
    font-family: "PretendardMedium";
    float: none !important;
    text-align: center;
  }

  /*하단배너*/
  .container-con {
    overflow: hidden;
  }
  .container-wrap .container-con-appdown {
    width: 100%;
    margin: 0 auto;
    padding: 239px 0;
  }
  .container-con-appdown .con-left {
    float: none;
    padding: 0;
    margin: 0 0 52px;
    text-align: center;
  }
  .container-con-appdown .con-left img {
    width: 220px;
    height: auto;
  }
  .container-con-appdown .con-right {
    float: none;
    text-align: center;
  }
  .container-con-appdown .con-right p {
    color: #01caff;
  }
  .container-con-appdown .con-right p:nth-child(1) {
    font-family: "PretendardMedium";
    line-height: 1.16;
    letter-spacing: -2.58px;
    font-size: 43px;
    margin-bottom: 19px;
  }
  .container-con-appdown .con-right p:nth-child(2) {
    font-family: "PretendardMedium";
    line-height: 1.16;
    letter-spacing: -1px;
    font-weight: normal;
    font-size: 25px;
    margin-bottom: 48px;
  }
  .m-con-text,
  .container-1-right-content {
    display: none;
  }
  .t-con-text {
    display: block;
    padding-top: 20px;
    font-family: "PretendardMedium";
    line-height: 1.18;
    letter-spacing: -1.6px;
    text-align: center;
    font-weight: bold;
    font-size: 53px;
    color: #ffffff;
  }
  .t-con-text > div > div {
    display: inline-block;
    margin: 0 7px;
  }
  .t-con-text .container-1-text-1 {
    font-family: "NanumSquareNeoBold";
    letter-spacing: -1.32px;
    font-weight: normal;
    font-size: 33px;
  }
  .t-con-text .font-highlight {
    background-image: url("../assets/imgs/dot.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 20px auto;
    padding-top: 7px;
  }
  .t-con-text p {
    margin-top: 16px;
    line-height: 1.56;
    letter-spacing: -0.72px;
    font-weight: 500;
    font-size: 18px;
  }
  .text-highlight {
    background-image: url("../assets/imgs/blue_dot2.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 5px auto;
    padding-top: 7px;
  }
  .text-bold {
    font-weight: bold;
  }
  .main-banner-appbtn .container-1-btn-top {
    width: 174px;
    height: 47px;
    padding: 7px 19px;
    margin-bottom: 20px;
    border-radius: 24px;
    background-color: #01caff;
    box-sizing: border-box;
  }
  .main-banner-appbtn .container-1-btn-top img {
    width: auto;
    height: 34px;
  }
  .main-banner-appbtn .container-1-btn-top.btn-and {
    margin-right: 22px;
  }
  .container-con-appdown .con-right .btn-googleplay {
    background: url("../assets/imgs/btn_gooleplay.png") no-repeat center center;
    display: block;
    width: 184px;
    height: 47px;
  }

  /*메인배너*/
  /* 230130 */
  .container-1-title {
    padding-top: 0;
    font-family: "NanumSquareNeoBold";
    font-size: 30px;
    /* font-weight: bold; */
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -1.2px;
    text-align: center;
    color: #ffffff;
  }
  /* 230130 */
  .text-3 {
    font-family: "NanumSquareNeoExtraBold";
    letter-spacing: -1.04px;
    font-size: 26px;
  }
  .container-1-title-1 {
    line-height: 1.7;
  }

  .t-con-text {
    line-height: 0.9;
  }
  .t-con-text > div > div {
    display: block;
    margin: 0;
  }
  .t-con-text .main-banner-appbtn {
    display: none;
  }
  /* 230130 letter-spacing -3.2 > -0.88 + font-size 40 > 22 + font-family NexonBold > Nexon */
  .t-con-text .text-2 {
    font-family: "NanumSquareNeoBold";
    letter-spacing: -0.88px;
    font-size: 22px;
  }
  .t-con-text .main-banner-applybtn {
    margin-top: 25px;
  }
  .t-con-text p {
    display: none;
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top {
    background-color: #3e3e3e;
    padding: 0;
    margin-bottom: 0;
    line-height: 47px;
  }
  .t-con-text .main-banner-appbtn .container-1-btn-top img {
    line-height: 47px;
  }
  /* 230130 width 206 > 230 + height 38 > 40 */
  .t-con-text .main-banner-applybtn .container-1-btn-bottom {
    display: block;
    width: 230px;
    height: 40px;
    padding: 0;
    border-radius: 24px;
    background: #3e3e3e;
    margin: 0 auto 10px !important;
    text-align: center;
    font-weight: bold;
    box-sizing: border-box;
  }
  .t-con-text .main-banner-applybtn .container-1-btn-bottom a {
    text-decoration: none;
  }
  .t-con-text .main-banner-applybtn .container-btn-bottom-text {
    font-family: "PretendardMedium";
    letter-spacing: -0.96px;
    text-align: center;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
  }

  /*메인컨텐츠*/
  .real-container .contents-wrap {
    background-color: #f4f4f4;
  }
  .real-container .contents-wrap:nth-child(2n-1) {
    background-color: #ffffff;
  }
  .t-con-text .container-1-left-content {
    display: block;
    /*background-image: url("../assets/imgs/img_daegu_logo_white_25px@2x.png");*/
    /*background-repeat: no-repeat;*/
    /*background-position-x: center;*/
    /*background-size: 104px auto;*/
    /*background-position: right 0 bottom 22px;*/
  }
  /* 230130 max-width 추가 + padding-bottom 추가 */
  .container-1-left-content {
    display: none;
    width: 100%;
    max-width: 450px;
    padding: 0 15px 0 15px;
    margin: 0 auto;
    overflow: hidden;
  }
  .container-1-left-content img {
    width: 100%;
    margin-bottom: -6px;
  }
  .contents-wrap .contents-main {
    width: 100%;
    margin: 0 auto;
    padding: 26px 0 48px;
  }
  /* 230130 */
  .sub-sec-1 .contents-wrap .contents-main {
    width: 100%;
    margin: 0 auto;
    padding: 20px 0 20px 0;
  }
  .sub-sec-1 .contents-wrap .contents-main > div[data-v-fae5bece]:has(.btn-row) {
  padding: 20px 0 20px 0; /* 원하는 패딩값 */
}
  .contents-main div:nth-child(1) {
    float: none;
  }
  .contents-main div:nth-child(2) {
    float: none;
  }
  .contents-main .contents-main-img {
    float: none;
    text-align: center;
  }
  /* 230130 width 80 > 70 */
  .contents-main .contents-main-img img {
    width: 70%;
  }
  /* 230130 */
  .sub-sec-2 .contents-wrap:first-child .contents-main-img img {
    width: 90%;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img {
    float: none !important;
    width: 100%;
    text-align: center;
    padding-top: 10px;
  }
  /* 230130 */
  .contents-main .no-bottom-margin img {
    width: 100%;
    height: auto;
    padding: 0 15vw 0 0;
  }
  /* 230130 */
  .contents-main .contents-main-sub-img img {
    width: 90%;
    height: auto;
  }
  .contents-main .contents-main-text {
    font-family: "PretendardMedium";
    float: none;
    text-align: center;
  }
  .contents-main .contents-main-text .main-headtit {
    font-family: "PretendardMedium";
    display: inline-block;
    background: linear-gradient(104deg, #00ffff -4%, #0093ff 102%);
    padding: 4px 16px;
    margin: 0 0 16px;
    border-radius: 21px;
    letter-spacing: -0.36px;
    white-space: nowrap;
    font-weight: 400;
    font-size: 16px;
    color: #fff;
  }
  .contents-main .contents-main-text .main-headtext {
    font-family: "NanumSquareNeoBold";
    line-height: 1.45;
    letter-spacing: -0.72px;
    font-weight: normal;
    font-size: 30px;
    color: #1fcaff;
    margin-bottom: 20px;
  }
  /* 230130 color 5c5c5c > 000000 */
  .contents-main .contents-main-text .main-context {
    font-family: "PretendardMedium";
    margin-bottom: 0;
    line-height: 1.64;
    letter-spacing: -0.56px;
    font-weight: 350;
    font-size: 18px;
    color: #000000;
  }
  /* 230130 */
  .contents-main .contents-main-text .sub-context {
    font-family: "PretendardMedium";
    margin-bottom: 0;
    line-height: 1.64;
    letter-spacing: -0.56px;
    font-weight: 350;
    font-size: 18px;
    color: #5c5c5c;
    padding-top: 10px;
  }
  /*하단배너*/
  .container-con {
    overflow: hidden;
  }
  /* 230130 padding-top 114px > 0 + padding-bottom 95 > 10*/
  .container-wrap .container-con-appdown {
    width: 100%;
    margin: 0 auto;
    padding: 0 0 10px 0;
  }
  .container-con-appdown .con-left {
    float: none;
    padding: 0;
    margin: 0 0 30px;
    text-align: center;
  }
  .container-con-appdown .con-left img {
    width: 140px;
    height: auto;
  }
  .container-con-appdown .con-right {
    float: none;
    text-align: center;
  }
  .container-con-appdown .con-right p {
    color: #01caff;
    display: none;
  }
  .m-con-text {
    display: block;
    font-family: "PretendardMedium";
    line-height: 1.18;
    letter-spacing: -1.6px;
    font-weight: bold;
    font-size: 40px;
    color: #1fc7ff;
  }
  .m-con-text .container-1-text-1 {
    font-family: "NanumSquareNeoBold";
    font-size: 33px;
    font-weight: normal;
  }
  .m-con-text .text-2 {
    font-family: "NanumSquareNeoBold";
  }
  .m-con-text .font-highlight {
    background-image: url("../assets/imgs/blue_dot2.png");
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 7px auto;
    padding-top: 10px;
  }

  .container-con-appdown .appdown-btn {
    width: 100%;
    padding: 16px 0;
    position: fixed;
    background: #1fcaff;
    bottom: 0;
    left: 0;
    z-index: 800;
  }
  .container-con-appdown .appdown-btn button {
    float: left;
    width: 50%;
    margin: 0;
  }

  .container-con-appdown .appdown-btn button img {
    width: auto;
    height: 34px;
  }
  .main-banner-appbtn .container-1-btn-top.btn-and {
    margin: 0;
  }
  .container-con-appdown .con-right .btn-googleplay {
    background: url("../assets/imgs/btn_gooleplay.png") no-repeat center center;
    display: block;
    width: 184px;
    height: 47px;
  }

  /*모바일 입점 버튼 추가*/
  /* 230130 margin-top 32px > 0 */
  .m-con-text .main-banner-applybtn {
    margin-top: 0;
  }
  /* 230130 width 206 > 250 + height 42 > 50 */
  .m-con-text .main-banner-applybtn .container-1-btn-bottom {
    background-color: #1fc7ff;
    display: block;
    width: 250px;
    height: 50px;
    /* margin: 20px 5px 0 22px; */
    padding: 0;
    border-radius: 24px;
    border: solid 2px #ffffff;
    margin: 0 auto 14px !important;
    text-align: center;
    font-weight: bold;
    box-sizing: border-box;
  }
  /* 230130 margin-bottom 0 > 40px */
  .m-con-text .main-banner-applybtn .container-1-btn-bottom:last-child {
    margin-bottom: 50px !important;
  }
  .m-con-text .main-banner-applybtn .container-1-btn-bottom a {
    display: block;
    text-decoration: none;
  }
  .m-con-text .main-banner-applybtn .container-btn-bottom-text {
    font-family: "PretendardMedium";
    font-size: 18px;
    font-weight: 350;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.9px;
    text-align: center;
    color: #ffffff;
  }
  /*하단배터 버튼 추가*/
  .container-con-appdown .container-1-btn-bottom {
    display: none;
  }
  /*추가*/
  .contents-wrap.sec-1 .contents-main {
    padding: 50px 0 !important;
  }
  .sec-tit {
    margin-bottom: 31px;
    font-family: "NanumSquareNeoBold";
    line-height: 1.21;
    letter-spacing: -0.72px;
    text-align: center;
    font-size: 28px;
    color: #1fcaff;
  }
  /* 230130 */
  .sec-sub-tit {
    font-family: "PretendardMedium";
    letter-spacing: -0.88px;
    text-align: center;
    font-size: 18px;
    color: #666666;
  }
  .sec-1 .sec-1-con {
    float: initial !important;
    width: 100%;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con .sec-1-img {
    overflow: hidden;
    text-align: center;
  }
  .sec-1 .sec-1-con .sec-1-img img {
    display: none;
  }
  .sec-1 .sec-1-con .sec-1-tit {
    font-family: "NanumSquareNeoBold";
    margin-bottom: 30px !important;
    text-align: center;
    line-height: 1.5;
    letter-spacing: -0.72px;
    font-size: 26px;
    color: #1fcaff;
  }
  .sec-1 .sec-1-con ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .sec-1 .sec-1-con ul li {
    display: block;
    width: 360px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }
  .sec-1 .sec-1-con ul li .img-cover {
    float: left !important;
    width: 50%;
    text-align: center;
  }
  .sec-1 .sec-1-con ul li img {
    width: 160px;
  }
  /* 230130 2 > odd */
  .sec-1 .sec-1-con ul li:nth-child(even) .img-cover {
    float: right !important;
  }
  .sec-1 .sec-1-con ul li .text-cover {
    float: right !important;
    width: 50%;
    padding: 26px 0;
  }
  .sec-1 .sec-1-con .sec-1-text {
    float: initial !important;
    width: 136px;
    background: #fff;
    border-radius: 20px;
    padding: 10px 14px;
    position: relative;
    margin: 0 auto;
  }
  /* 230130 2 > 2n */
  .sec-1 .sec-1-con ul li:nth-child(2n) .text-cover {
    float: left !important;
  }
  .sec-1 .sec-1-con .sec-1-text b {
    font-family: "PretendardMedium";
    margin-bottom: 6px;
    letter-spacing: -0.56px;
    font-weight: bold;
    font-size: 16px;
    color: #4e4e4e;
  }
  .sec-1 .sec-1-con .sec-1-text span {
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.56px;
    font-weight: 350;
    font-size: 16px;
    color: #5c5c5c;
  }
  .sec-1 .sec-1-con ul li .sec-1-text::after {
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    border: 20px solid transparent;
    border-left-width: 0;
    border-right-color: #fff;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
  /* 230130 2 > 2n */
  .sec-1 .sec-1-con ul li:nth-child(2n) .sec-1-text::after {
    border-left-width: 20px;
    border-right-width: 0;
    border-left-color: #fff;
    left: auto;
    right: -12px !important;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
  }
  .sec-1 .sec-1-con .sec-1-text span {
    display: block;
  }
  .sec-2 {
    background-color: #1fcaff !important;
  }
  .sec-2 .contents-main {
    padding: 50px 0;
  }
  .sec-2 .contents-main .sec-2-con {
    float: initial !important;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit {
    font-family: "NanumSquareNeoBold";
    margin-bottom: 35px;
    line-height: 1.46;
    letter-spacing: -0.72px;
    text-align: center;
    font-size: 28px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con .sec-2-tit .font-highlight {
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 90%;
    padding-top: 2.3%;
  }
  .sec-2 .contents-main .sec-2-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
    width: 80%;
    margin: 0 auto;
  }
  .sec-2 .contents-main .sec-2-con ul li {
    width: 100%;
    display: inline-block;
    padding-bottom: 10px;
  }
  .sec-2 .contents-main .sec-2-con ul li:last-child {
    width: 100%;
    display: inline-block;
    padding-bottom: 0px;
  }
  .sec-2 .contents-main .sec-2-con ul li:nth-child(1),
  .sec-2 .contents-main .sec-2-con ul li:nth-child(2) {
    margin-bottom: 35px;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text {
    font-family: "GmarketSansBold";
    display: block;
    width: 140px;
    height: 140px;
    background: #fff;
    border-radius: 50%;
    padding: 52px 0;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    font-weight: bold;
    font-size: 45px;
    margin: 0 auto 20px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li .circle-text span {
    font-family: "GmarketSansBold";
    display: inline-block;
    font-weight: bold;
    font-size: 24px;
    color: #333;
  }
  .sec-2 .contents-main .sec-2-con ul li b {
    display: block;
    font-family: "PretendardBold";
    margin-bottom: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: #fff;
  }
  .sec-2 .contents-main .sec-2-con ul li span {
    display: block;
    font-family: "PretendardMedium";
    line-height: 1.64;
    letter-spacing: -0.56px;
    text-align: center;
    font-size: 18px;
    font-weight: 350;
    color: #fff;
  }
  .sec-3 {
    width: 100%;
    background-color: #f4f4f4 !important;
  }
  .sec-3 .contents-main {
    padding: 76px 0;
  }
  .sec-3 .contents-main .sec-3-con {
    float: inherit !important;
  }
  .sec-3 .contents-main .sec-3-con ul {
    overflow: hidden;
    padding: 0;
    list-style: none;
    width: 80%;
    margin: 0 auto;
  }
  .sec-3 .contents-main .sec-3-con ul li {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
  }
  .sec-3 .contents-main .sec-3-con ul li:nth-child(1),
  .sec-3 .contents-main .sec-3-con ul li:nth-child(2) {
    margin-bottom: 56px;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic {
    display: block;
    background: #ffffff;
    width: 80%;
    height: 80%;
    margin: 0 auto 20px;
    overflow: hidden;
  }
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1);
    -webkit-transform: scale(1);
    transition: all 0.3s;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-pic img {
    width: 100%;
    height: 100%;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transition: all 0.3s;
  }
  /* 230130 color 5c5c5c > 000000 */
  .sec-3 .contents-main .sec-3-con ul li .sec-3-li .rectangle-text {
    display: -webkit-box;
    margin: 0 auto;
    width: 80%;
    height: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    line-height: 1.64;
    letter-spacing: -0.56px;
    font-weight: 350;
    font-size: 18px;
    transition: all 0.3s;
    color: #000000;
    margin: 0 auto;
    text-align: center;
  }
  .sec-3 .contents-main .sec-3-con ul li:hover .sec-3-li .rectangle-text {
    color: #1fc7ff;
    transition: all 0.3s;
  }
  /* 230130 sec-4 클래스 영역에 포함된 기존 css 주석처리 + css 새로 적용 */
  .sec-4 {
    width: 100%;
    background-color: #ffffff !important;
  }
  .sec-4 .contents-main {
    padding: 76px 0 0 0;
  }
  .sec-4 .contents-main .sec-4-con {
    float: inherit !important;
  }
  .sec-4 .contents-main .sec-4-con .sec-tit {
    margin-bottom: 10px;
  }
  /* 230130 position 추가 + width 추가 + margin-bottom 42px > 50px */
  .sec-4 .contents-main .sec-4-con .sec-4-video {
    background: #ffffff;
    margin: 42px auto 50px auto;
    text-align: center;
    position: relative;
    width: 90%;
  }
  /* 230130 */
  .sec-4 .contents-main .sec-4-con .sec-4-video iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  /* 230130 */
  .iframe16To9 {
    padding-top: 50.6%;
  }
  .sec-4 .contents-main .sec-4-con .sec-4-video .daegu-m4 {
    width: 544px;
  }
  /* .sec-4 .contents-main .sec-4-con ul {
    width: 408px;
    padding: 0;
    list-style: none;
    text-align: center;
    margin: 0 auto;
  }
  .sec-4 .contents-main .sec-4-con ul li {
    display: inline-block;
    margin: 0 15px;
  }
  .sec-4 .contents-main .sec-4-con ul li:nth-child(1),
  .sec-4 .contents-main .sec-4-con ul li:nth-child(2) {
    margin-bottom: 30px;
  }
  .sec-4 .contents-main .sec-4-con ul li button {
    border-radius: 24px;
    width: 174px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios {
    background-color: #3e3e3e !important;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and img,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios img {
    width: auto;
    height: 34px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b {
    border: solid 2px #3e3e3e;
    font-family: "PretendardMedium";
    text-decoration: none;
    letter-spacing: -1.2px;
    line-height: 0;
    font-weight: 300;
    font-size: 20px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-line-b:hover {
    border: solid 2px #1fc7ff;
    color: #1fc7ff;
    transition: all 0.3s;
  } */
  .sec-4 .contents-main .sec-4-con ul {
    padding: 0;
    list-style: none;
    text-align: center;
    width: 100%;
    padding: 16px 0;
    position: fixed;
    background: #1fcaff;
    bottom: 0;
    left: 0;
    z-index: 800;
  }
  .sec-4 .contents-main .sec-4-con ul li {
    display: inline-block;
    width: 50%;
  }
  .sec-4 .contents-main .sec-4-con ul li button {
    border-radius: 24px;
    width: 100%;
    height: 47px;
    text-align: center;
    line-height: 47px;
    vertical-align: middle;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios {
    background-color: #1fcaff !important;
  }
  .sec-4 .contents-main .sec-4-con ul li button.btn-and img,
  .sec-4 .contents-main .sec-4-con ul li button.btn-ios img {
    width: auto;
    height: 34px;
    vertical-align: middle;
  }
  .btn-row {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
  }

  .container-btn-img-bottom,
  .container-btn-img-bottom-white {
    font-family: "PretendardMedium";
    transition: all 0.3s;
    border-radius: 24px;
    padding: 6px 16px;
    width: 140px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    top: -5px;
  }

  .container-btn-img-bottom {
    background: #3e3e3e 0% 0% no-repeat padding-box;
    border: none;
  }

  .container-btn-img-bottom-white {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: #333333 solid 1px;
  }

  .container-btn-img-bottom-text,
  .container-btn-img-bottom-text-black {
    text-align: center;
    font: normal normal normal 16px/16px PretendardMedium;
    letter-spacing: -1.08px;
    opacity: 1;
  }

  .container-btn-img-bottom-text {
    color: #ffffff;
  }

  .container-btn-img-bottom-text-black {
    color: #000000;
  }
}
</style>
